import { useSnackbar } from 'notistack';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, Route, useLocation } from 'react-router-dom';
import adminRoutesConstant from '../constants/adminRoutesConstant';
import { logoutDispatcher } from '../redux/dispatchers/authDispatcher';
import AdminRoutes from './AdminRoutes';

const Routes = () => {
    const auth = useSelector(state => state.auth)
    const dispatch = useDispatch()
    const location = useLocation();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [autoLogoutNotificationTimerKey, setAutoLogoutNotificationTimerKey] = React.useState(null)

    const AppRoutes = (each, index) => (
        <Route key={index} exact path={each.path} component={each.component} />
    );


    const handleAutoLogoutNotification = (timeout) => {

        // if notification timeout is set then clear it first then set another one
        // will be better if stored in redux
        if (!!autoLogoutNotificationTimerKey) {
            window.clearTimeout(autoLogoutNotificationTimerKey)
        }

        const logoutNotificationTimerKey = window.setTimeout(() => {
            const key = enqueueSnackbar('Your session is expired! Please login again.', {
                variant: 'error',
                autoHideDuration: (60000 * 15),       // show this message for 15 min
                onClick: () => {
                    closeSnackbar(key);
                }
            })
        }, timeout);
        setAutoLogoutNotificationTimerKey(logoutNotificationTimerKey)
    }

    const logoutExpiredToken = (tokenExpiryTimestamp) => {
        const currentTimestamp = Date.now()
        if (tokenExpiryTimestamp < currentTimestamp) {
            dispatch(logoutDispatcher())
        }
        // notification for auto logout 
        else {
            const timeout = tokenExpiryTimestamp - currentTimestamp
            handleAutoLogoutNotification(timeout)
        }
    }

    const handleAutoLogout = () => {
        if (!!auth.admin.tokenExpiryTimestamp) {
            logoutExpiredToken(auth.admin.tokenExpiryTimestamp);
        }
        else if (!!auth.vendor.tokenExpiryTimestamp) {
            logoutExpiredToken(auth.vendor.tokenExpiryTimestamp);
        }
    }

    React.useEffect(() => {
        if (!!auth.admin.jwt) {
            handleAutoLogout()
        }
    }, [auth])


    return (
        <>
            {adminRoutesConstant.baseRoutes.map(AppRoutes)}
            {
                (location.pathname.includes(adminRoutesConstant.ADMIN_PREFIX)) ?
                    <AdminRoutes /> :
                    <Redirect to={adminRoutesConstant.adminPaths.AdminLoginScreen.url()} />
            }
        </>
    )
}

export default Routes
